/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import {
  themeGet,
  space,
  width,
  height,
} from 'styled-system';
import MUIRadio from '@material-ui/core/Radio';

const defaultProps = {
  w: [16, null, 28],
  height: [16, null, 28],
  ml: [10, null, 30],
  mr: [15, null, 25],
};

export const StyledRadioIcon = styled.i`
  font-style: normal;
  display: flex;
  align-items: center;
  justify-content: center;
  ${() => width(defaultProps)}
  ${() => height(defaultProps)}
  ${() => space(defaultProps)}


  ${(props) => ({
    border: `1px ${themeGet('colors.gray.10')(props)} solid`,
  })}
  background: #FFFFFF;
  color: #FFFFFF;
  border-radius: 50%;
  flex: none;
  position: relative;

  &::after {
    content: '';
    ${() => width({ w: [10, null, 18] })}
    ${() => height({ height: [10, null, 18] })}
    border-radius: 50%;
    background: transparent;
  }

  ${(props) => (props.checked || props.hovering ? {
    '&::after': {
      background: props.checked
        ? themeGet('colors.blue.0')(props)
        : themeGet('colors.gray.10')(props),
      transition: `background ${themeGet('transition')(props)}ms ease`,
    },
  } : {})}
`;

export const StyledRadio = styled(MUIRadio)`
  && {
    padding: 0;
  }
`;

const Radio = ({
  hovering,
  ...props
}) => {
  return (
    <StyledRadio
      icon={<StyledRadioIcon hovering={hovering} />}
      checkedIcon={<StyledRadioIcon checked />}
      disableRipple
      {...props}
    />
  );
};

Radio.propTypes = {
  hovering: PropTypes.bool,
};

export default Radio;
